import apiRequest from "../../helpers/apiRequest";

export default async (university) => {
    return await apiRequest({
        method: 'get',
        url: `studies/degrees/?university_slug${university}/`,
    })
}
